var res = [{"key":"10/11","value":"66.1"},{"key":"11/12","value":"50.4"},{"key":"12/13","value":"47.3"},{"key":"13/14","value":"48.0"},{"key":"14/15","value":"43.0"},{"key":"15/16","value":"39.0"},{"key":"16/17","value":"39.9"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/interuptions-average.csv
// module id = 616
// module chunks = 0